import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

class ScrollHandler extends PureComponent {
    static propTypes = {
        /** Function to call on scroll or on resize with true/false if the component is in view or not */
        onLazyLoad: PropTypes.func,
        /**
         * Override to directly change the IntersectionObserver's `rootMargin` property.
         * If you supply this prop, the `threshold` prop will be ignored.
         * Read more at https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
         */
        rootMargin: PropTypes.string,
        /**
         * The "buffer" in pixels - i.e. how many pixels before the content enters the viewport from the bottom, should the element be considered 'visible'?
         * Useful for lazy loading things in advance, so it's mostly used for `<Unveil>`.
         * Please note this is NOT the same as IntersectionObserver's `threshold` property.
         */
        threshold: PropTypes.number,
        /** If we want to stop observing after first intersect, for example for <Unveil> it only needs to happen once */
        unobserveAfterIntersect: PropTypes.bool
    };

    static defaultProps = {
        onLazyLoad: () => {},
        threshold: 0
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {threshold, rootMargin} = this.props;

        const rootMarginValue = rootMargin
            ? rootMargin
            : `0px 0px ${threshold}px 0px`;

        this.observer = new IntersectionObserver(this.observeEntries, {
            rootMargin: rootMarginValue
        });

        this.observer.observe(this.element);
    }

    componentWillUnmount() {
        this.observer.unobserve(this.element);
    }

    observeEntries = (entries) => {
        const {onLazyLoad, unobserveAfterIntersect} = this.props;

        entries.forEach((entry) => {
            onLazyLoad(entry.isIntersecting);
            if (entry.isIntersecting && unobserveAfterIntersect) {
                this.observer.unobserve(entry.target);
            }
        });
    };

    render() {
        const {children} = this.props;

        return (
            <div
                ref={(el) => {
                    this.element = el;
                }}
            >
                {children}
            </div>
        );
    }
}

export default ScrollHandler;
